import Logo from "../../static/assets/logo_rvg.png";
import Loader from "../../components/utils/Loading";

const LoginRedirectScreen = () => (
  <div className="login-page">
    <div className="header">
      <img src={Logo} alt="Logo Akanthas" className="logo" />
    </div>
    <Loader color="#f5f5f5" height="100vh" />
  </div>
);

export default LoginRedirectScreen;
